/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetFileRenditionsQueryResponse, FilesControllerGetFileRenditionsPathParams, FilesControllerGetFileRenditionsQueryParams, FilesControllerGetFileRenditions401, FilesControllerGetFileRenditions403 } from "../../models/filesController/FilesControllerGetFileRenditions";

function getFilesControllerGetFileRenditionsUrl(id: FilesControllerGetFileRenditionsPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/files/${id}/renditions` as const }  
  return res
}

/**
 * @summary Get file renditions for a file
 * {@link /api/v1/files/:id/renditions}
 */
export async function filesControllerGetFileRenditions(id: FilesControllerGetFileRenditionsPathParams["id"], params?: FilesControllerGetFileRenditionsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerGetFileRenditionsQueryResponse, ResponseErrorConfig<FilesControllerGetFileRenditions401 | FilesControllerGetFileRenditions403>, unknown>({ method : "GET", url : getFilesControllerGetFileRenditionsUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}